import jQuery from 'jquery'

class LeadForm {
    
    /**
     * Construct component
     * @param form
    */
    constructor(form) {
        
        /**
         * Form jQuery object
         * @type {object}
        */
        this.form = form
        
        this.bindEvents()
        
    }
    
    /**
     * Handle successful form submit
    */
    formSuccess() {
        
        //Retrieve input containing type of Lead
        const input = this.form.find('[name="type_id"]')
        
        //Track event
        gtag('event', (input.is('select') ? input.find('option:selected') : input.data('name')), {
            event_category: 'Lead'
        })
        
    }
    
    /**
     * Bind events
    */
    bindEvents() {
        this.form.on('form-ajax-success', this.formSuccess.bind(this))
    }
    
}

jQuery(document).ready(() => {
    
    //Cancel if Google tag isn't present
    if (typeof gtag != 'function') {
        return
    }
    
    const form = jQuery('#request-callback-form')
    
    if (form.length > 0) {
        new LeadForm(form)
    }
    
})

export default LeadForm